import React from 'react';

import styles from './index.module.css';

export const Button = ({ children, size = 'm', ...props }) => {
    return (
        <button {...props} className={[styles.button, styles[size]].join(' ')}>
            {children}
        </button>
    );
};
